import { render } from "./Success-Result.vue?vue&type=template&id=5251945e"
import script from "./Success-Result.vue?vue&type=script&lang=js"
export * from "./Success-Result.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__